import React, { useState } from 'react';

import { getEnvDomain } from '../../config';
import { displayShortDateOrNA } from '../../utils/Format/Format';
import { newFundUtil, getBoradAssetCategory } from '../../utils/fund-info';
import { CARD_NAMES } from '../../utils/constants';
import styles from './TopTenIssuers.css';
import Card from '../../components/Card/Card';
import ErrorMessageNewFund from '../../components/ErrorMessages/ErrorMessageNewFund';
import ErrorMessageNoData from '../../components/ErrorMessages/ErrorMessageNoData';
import GqlQueryWrapper from '../../components/GqlQueryWrapper/GqlQueryWrapper';
import Table from '../../components/Table/Table';
import TablePreRender from '../../components/Table/Table.prerender';
import TitleWithDescription from '../../components/TitleWithDescription/TitleWithDescription';
import Toggle from '../../components/Toggle/Toggle';
import PeriodSelector from '../../components/PeriodSelector/PeriodSelector';

import { TOP_TEN_ISSUERS } from './queries';
import { TopTenIssuersUtil } from './util';

const TopTenHoldingsIssuers = ({ ticker }) => {
    const [selectedPeriod, setSelectedPeriod] = useState('month');
    const [selectedDate, setSelectedDate] = useState(null);

    const togglePeriod = (period) => {
        setSelectedPeriod(period);
    };

    const handleChange = (event) => {
        const date = event.target.value;
        setSelectedDate(date);
    };

    const trpDomain = getEnvDomain(window.location.host);

    const getCardName = (useGuarantor) =>
        useGuarantor
            ? CARD_NAMES.TOP_TEN_GUARANTORS
            : CARD_NAMES.TOP_TEN_ISSUERS;

    return (
        <Card>
            <GqlQueryWrapper
                query={TOP_TEN_ISSUERS}
                variables={{ ticker }}
                dataFunc={TopTenIssuersUtil(selectedPeriod, selectedDate)}
                placeholder={() => <TablePreRender />}
                unbatch
            >
                {({
                    data: {
                        data,
                        asOfDate,
                        inceptionDate,
                        broadAssetClass,
                        percentHoldings,
                        totalHoldings,
                        name,
                        effectiveDates,
                        buttonList,
                        useGuarantor
                    }
                }) => (
                    <React.Fragment>
                        {data &&
                            data.length > 0 && (
                                <React.Fragment>
                                    <div className="title-group">
                                        <div className="title">
                                            <TitleWithDescription
                                                title={`${getCardName(
                                                    useGuarantor
                                                )}${
                                                    getBoradAssetCategory(
                                                        broadAssetClass
                                                    )
                                                        ? ' - Equity Only'
                                                        : ''
                                                }`}
                                            />
                                        </div>
                                        <div className="buttons">
                                            <Toggle
                                                data={buttonList}
                                                selected={selectedPeriod}
                                                toggle={togglePeriod}
                                            />
                                        </div>
                                    </div>
                                    <div className="captions">
                                        <div className="as-of">
                                            <PeriodSelector
                                                selectedPeriod={selectedPeriod}
                                                data={effectiveDates}
                                                selectedDate={asOfDate}
                                                handleChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                    <div
                                        id="top-10-issuers-table"
                                        className="tables"
                                    >
                                        <Table
                                            data={{
                                                data,
                                                headers: [
                                                    parseFloat(
                                                        percentHoldings
                                                    ) > 0
                                                        ? `Represents\xa0${percentHoldings}\xa0of Total\xa0Net\xa0Assets`
                                                        : `` // ,
                                                    // '% of Fund'
                                                ]
                                            }}
                                        />
                                    </div>
                                    <div className="disclaimer">
                                        As of {displayShortDateOrNA(asOfDate)},
                                        the {name} had a total of{' '}
                                        {totalHoldings} holdings.
                                    </div>
                                    <div className="disclaimer">
                                        Prior to May 31, 2024, the information
                                        shown does not reflect any ETFs that the
                                        portfolio may have held.
                                    </div>
                                    <div className="disclaimer">
                                        The total of the holdings in the table
                                        may not equal the percentage of total
                                        net assets shown because of rounding.
                                    </div>
                                    <div className="disclaimer">
                                        {getBoradAssetCategory(
                                            broadAssetClass
                                        ) ||
                                        ['RPSIX', 'PRSGX', 'PSILX'].includes(
                                            ticker
                                        )
                                            ? `Holdings are as of the date indicated and are subject to change.`
                                            : `Holdings are shown at the issuer/company level as of the date indicated and are subject to change.`}
                                    </div>
                                    <a
                                        className="view-all"
                                        href={`https://${trpDomain}/personal-investing/funds/mutual-funds/prospectuses-reports/portfolio-holdings.html`}
                                    >
                                        View the Complete Portfolio of
                                        Investments
                                    </a>
                                </React.Fragment>
                            )}
                        {data.length === 0 &&
                            (newFundUtil(inceptionDate) ? (
                                <ErrorMessageNewFund
                                    cardName={getCardName(useGuarantor)}
                                />
                            ) : (
                                <ErrorMessageNoData
                                    cardName={getCardName(useGuarantor)}
                                />
                            ))}{' '}
                    </React.Fragment>
                )}
            </GqlQueryWrapper>
            <style jsx>{styles}</style>
        </Card>
    );
};

export default TopTenHoldingsIssuers;
